export default __webpack_public_path__ + "static/media/expenditure.817719ea.png";